// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"bd8c68af","426":"6df294e6","431":"8084b614","488":"a579d194","810":"4c982a5a","821":"d9b36d6f"}[chunkId] + ".chunk.js";
};